
<template>
  <div class="maf-input" ref="mafInput">
    <div class="display-flex">
      <label
        class="maf-font-weight"
        :style="{ color: labelColor }"
        v-text="name"
      ></label>
      <span style="color: red" v-show="isRequiredLabel">*Required</span>
      <span class="tip-icon reduced-tip" v-if="tip" ref="tipIcon">
        <p v-text="tip"></p>
      </span>
    </div>
    <div
      class="maf-s-input"
      :style="{ height: height + 'px', width: width + 'px' }"
      @click.stop="focus($event)"
    >
      <input
        @keyup.stop="keyup($event)"
        @keydown.stop="keydown($event)"
        :readonly="stdPicklist || isPicklistField"
        :type="inputType"
        v-if="!stdPicklist"
        ref="inputEle"
        v-model="field"
        :style="{
          width: isPicklistField ? 0 : width - 60 + 'px',
          'background-color': isLock ? '#E8EAEC' : '#fff'
        }"
        :disabled="disabled"
        @blur="blur($event)"
        maxlength="254"
        @focus="focus($event)"
      />
      <span
        v-if="isPicklistField && !stdPicklist"
        v-text="selectedOption.label"
        class="picklist-label"
        :style="{ color: !value ? 'grey' : '#000' }"
      ></span>
      <select
        v-if="stdPicklist"
        class="maf-picklist date grey"
        v-model="field"
        @blur="blur($event)"
        :style="{ color: field ? '#393C40' : '#878787' }"
        @focus="focus($event)"
      >
        <div v-for="(opt, index) in options" :key="index">
          <option v-text="opt.label" :value="opt.value"></option>
        </div>
      </select>
      <svg
        :width="width + 'px'"
        :height="height + 'px'"
        :viewBox="'0 0 ' + width + ' ' + height"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" :fill="svgColor" fill-rule="evenodd">
          <g>
            <rect
              :stroke="strokeColor"
              x="0.5"
              y="0.5"
              :width="width - 1"
              :height="height - 1"
              rx="5"
            ></rect>
            <path
              d="M236,27 L241.00297,27 C241.553614,27 242,27.4438648 242,28 C242,28.5522847 241.546964,29 241.00297,29 L234.99703,29 C234.722198,29 234.473338,28.8894285 234.292988,28.7095138 C234.111528,28.5233314 234,28.2744796 234,28.0029699 L234,21.9970301 C234,21.4463856 234.443865,21 235,21 C235.552285,21 236,21.4530363 236,21.9970301 L236,27 Z"
              :fill="labelColor"
              :transform="
                'translate(' +
                  (width - 30) +
                  ', 25) rotate(-45) translate(-238, -25)'
              "
              v-show="isPicklistField && this.disabled === false"
            ></path>
          </g>
        </g>
      </svg>
      <svg
        v-show="isLock"
        style="position: absolute; right: 15px; top: 18px;"
        width="9px"
        height="13px"
        viewBox="0 0 9 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="LC-App"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="0.10-Application-Dashboard-After-creating-an-new-application"
            transform="translate(-805.000000, -271.000000)"
          >
            <g id="Group-16" transform="translate(597.000000, 260.000000)">
              <g id="Group-19" transform="translate(205.000000, 10.000000)">
                <rect id="Rectangle" x="0" y="0" width="15" height="15"></rect>
                <path
                  d="M10.7142857,6.85 L10.7142857,4.25 C10.7142857,2.45795 9.27171429,1 7.5,1 C5.727,1 4.28571429,2.45795 4.28571429,4.25 L4.28571429,6.85 C3.57664286,6.85 3,7.4324 3,8.15 L3,12.7 C3,13.41695 3.57664286,14 4.28571429,14 L10.7142857,14 C11.4233571,14 12,13.41695 12,12.7 L12,8.15 C12,7.4324 11.4233571,6.85 10.7142857,6.85 Z M7.5,11.4 C6.96771429,11.4 6.53571429,10.9632 6.53571429,10.425 C6.53571429,9.8868 6.96771429,9.45 7.5,9.45 C8.03228571,9.45 8.46428571,9.8868 8.46428571,10.425 C8.46428571,10.9632 8.03228571,11.4 7.5,11.4 Z M9.42857143,6.85 L5.57142857,6.85 L5.57142857,4.25 C5.57142857,3.1749 6.43671429,2.3 7.5,2.3 C8.56328571,2.3 9.42857143,3.1749 9.42857143,4.25 L9.42857143,6.85 Z"
                  id="Shape"
                  fill="#FFFFFF"
                  fill-rule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span
        v-if="symbol"
        class="currency-symbol notranslate"
        :style="{
          color: field ? '#393C40' : '#878787',
          top: height / 2 - 10 + 'px'
        }"
        >{{ symbol }}</span
      >
      <ul
        ref="optionsRef"
        style="width: inherit"
        class="options"
        v-show="!stdPicklist && ((isPicklistField && isActive) || selecting)"
        @mouseenter="(selecting = true)"
        @mouseleave="(selecting = false)"
      >
        <div v-for="opt in options" :key="opt">
          <li
            v-text="opt.label"
            @click.stop="setField(opt)"
            :class="{ selected: opt.value === field }"
          ></li>
        </div>
      </ul>
      <ul
        :style="{ width: width + 'px' }"
        class="options suggestions"
        v-show="isShowAddress"
      >
        <li v-for="sug in suggestions" @click="setAddress(sug)" :key="sug">
          <span v-text="getAddressText(sug)"></span>
        </li>
      </ul>
    </div>
    <div
      v-if="error && error != 'no-text'"
      class="maf-font-weight"
      :style="errorMsgStyle"
    >
      <span v-text="error"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MafInput',
  props: {
    value: {
      type: String,
      default() {
        return '';
      }
    },
    name: {
      type: String,
      default() {
        return '';
      }
    },
    width: {
      type: Number,
      default() {
        return 0;
      }
    },
    height: {
      type: Number,
      default() {
        return 0;
      }
    },
    tip: {
      type: String,
      default() {
        return '';
      }
    },
    required: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isRequiredLabel: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    type: {
      type: String,
      default() {
        return '';
      }
    },
    maxValue: {
      type: Number,
      default() {
        return 0;
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    stdPicklist: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isDay: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isMonth: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isYear: {
      type: Boolean,
      default() {
        return false;
      }
    },
    target: {
      type: Object,
      default() {
        return {};
      }
    },
    sectionName: {
      type: String,
      default() {
        return '';
      }
    },
    isLockField: {
      type: Boolean,
      default() {
        return false;
      }
    },
    uscisRecord: {
      type: Object,
      default() {
        return {};
      }
    },
    noPlaceholder: {
      type: Boolean,
      default() {
        return false;
      }
    },
    mobile: {
      type: String,
      default() {
        return '';
      }
    },
    addressFields: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  created() {
    this.field = this.value;
    if (this.isPicklistField && this.options && this.options.length > 0) {
      if (this.options[0].value) {
        if (this.isDay) {
          this.options.unshift({ label: 'Day', value: '' });
        } else if (this.isMonth) {
          this.options.unshift({ label: 'Month', value: '' });
        } else if (this.isYear) {
          this.options.unshift({ label: 'Year', value: '' });
        } else {
          this.options.unshift({ label: 'Select an option', value: '' });
        }
      }
      if (!this.field) {
        this.selectedOption = this.options[0];
      }
    }
  },
  mounted() {
    this.$on('invalid', err => {
      this.error = err || 'This field is required';
    });

    if (this.type === 'unit') {
      this.$refs.inputEle.setAttribute(
        'placeholder',
        'Unit or apartment, e.g. #2'
      );
    }

    if (
      this.type === 'number' ||
      this.isCurrecnyField ||
      this.isRoutingNumberField ||
      this.isAccountNumberField ||
      this.isPercentageField
    ) {
      this.$refs.inputEle.setAttribute(
        'onkeypress',
        'return (/[0-9]/.test(String.fromCharCode(event.keyCode)))'
      );

      if (this.type === 'number') {
        this.$refs.inputEle.setAttribute('placeholder', '#');
        this.$refs.inputEle.setAttribute('maxlength', 2);
      }

      if (this.isCurrecnyField && this.noPlaceholder !== true) {
        this.$refs.inputEle.setAttribute('placeholder', '0/month');
      }

      if (this.isRoutingNumberField) {
        this.$refs.inputEle.setAttribute('maxlength', 9);
        this.$refs.inputEle.setAttribute('placeholder', '');
      }

      if (this.isAccountNumberField) {
        this.$refs.inputEle.setAttribute('maxlength', 20);
        this.$refs.inputEle.setAttribute('placeholder', '');
      }

      if (this.isPercentageField) {
        this.$refs.inputEle.setAttribute('maxlength', 4);
        this.$refs.inputEle.setAttribute('placeholder', '%');
      }
    }

    if (this.isZipCodeField) {
      this.$refs.inputEle.setAttribute('maxlength', 5);
    }

    if (this.tip) {
      this.$refs.tipIcon.onclick = e => {
        e.stopPropagation();
      };
    }

    if (this.type === 'date') {
      this.$refs.inputEle.setAttribute('type', 'date');
      this.$refs.inputEle.classList.add('date');
    }
  },
  data() {
    return {
      isActive: false,
      field: '',
      selecting: false,
      selectedOption: {},
      error: '',
      index: 0,
      suggestions: [],
      suggestionsSelect: [],
      isAutoCompleteAddress1: false,
      isAutoCompleteUnitApt: false,
      searchKey: '',
      contactPhone: '',
      smartyStreetsAPI:
        'https://us-autocomplete-pro.api.smartystreets.com/lookup',
      smartyStreetsAPIKey: '19496759020014823'
    };
  },
  watch: {
    value: function(val) {
      this.field = val;
    },

    field: function(val) {
      let newVal = val;
      this.field = val;

      if (this.isMoileField && val) {
        this.formatPhone();
      }

      if (this.isSSNORITINField && val && !this.isLockField) {
        this.formatSSNOrITIN();
      }

      if (this.isAddressField && !this.isAutoCompleteAddress1) {
        this.suggest('');
      }

      if (this.isPicklistField && this.options) {
        this.options.forEach(item => {
          if (this.field === item.value) {
            this.selectedOption = item;
          }
        });
      }

      if (newVal) {
        if (this.isCurrecnyField) {
          newVal = newVal ? (newVal + '').replace(/[^\d.]/g, '') : '';
          if (parseInt((newVal + '').replace(/,/g, '')) > this.maxValue) {
            this.error = 'no-text';
          } else {
            this.clearErrorInput();
          }
          newVal = this.formatNumber(val + '');
        }

        if (this.isNumberField) {
          if (newVal > this.maxValue) {
            this.error = 'no-text';
          } else {
            this.clearErrorInput();
          }
        }

        if (this.isZipCodeField) {
          newVal = newVal ? newVal.replace(/[^\d.]/g, '') : '';
          this.field = newVal;
        }
      }

      if (this.isPercentageField) {
        this.formatPercentage();
      }

      this.$emit('input', newVal);
      this.error = '';

      if (this.uscisRecord) {
      }

      this.monitorContactPhone();
    },
    index: function(val, oldVal) {
      // Set Address if the index changed
      if (
        val > 0 &&
        val < this.suggestionsSelect.length + 1 &&
        this.suggestionsSelect.length > 0 &&
        this.suggestions.length > 0
      ) {
        // eslint-disable-next-line no-undef
        $('.suggestions li').css('background-color', '#fff');
        // eslint-disable-next-line no-undef
        $('.suggestions li').css('color', '#000');
        // eslint-disable-next-line no-undef
        $('.suggestions li:nth-child(' + val + ')').css(
          'background-color',
          '#359BE0'
        );
        // eslint-disable-next-line no-undef
        $('.suggestions li:nth-child(' + val + ')').css('color', '#fff');
      }
    },
    error: function(val) {
      this.setErrorSectionNameToParent(val);
    },
    required: function(val) {
      if (this.field.replace(/[^\d]/g, '').length === 0 && !val) {
        this.error = '';
      }
    },
    mobile: function(val) {
      if (val && this.contactPhone && this.contactPhone.length === 10) {
        this.compareContactPhoneToMobile(
          val.replace(/[^\d.]/g, ''),
          this.contactPhone,
          ''
        );
      }
    }
  },
  methods: {
    formatSSNOrITIN() {
      let val = this.field ? this.field.replace(/[^\d.]/g, '') : '';

      if (val.length > 9) {
        val = val.substr(0, 9);
      }

      let ssn = '___ - __ - ____';
      let arr = ssn.split('');
      let position = 0;

      for (let i = 0; i < val.length; i++) {
        if (i < 3) {
          position = i;
        } else if (i < 5) {
          position = i + 3;
        } else if (i < 9) {
          position = i + 6;
        }
        arr[position] = val[i];
      }

      this.$nextTick(() => {
        this.field = arr.join('');
        this.setSsnItinPosition(position + 1);
      });
    },
    setSsnItinPosition(position) {
      let ssnItinEle = this.$refs.inputEle;

      if (position > this.selectionStart) {
        switch (this.selectionStart) {
          case 1:
            position = 1;
            break;
          case 4:
          case 5:
            position = 7;
            break;
          case 6:
            position = 3;
            break;
          case 9:
          case 10:
            position = 12;
            break;
          case 11:
            position = 8;
            break;
          default:
            position = this.selectionStart;
        }
      }

      if (ssnItinEle.setSelectionRange) {
        setTimeout(() => {
          ssnItinEle.setSelectionRange(position, position);
        }, 0);
      } else if (ssnItinEle.createTextRange) {
        var textRange = ssnItinEle.createTextRange();
        textRange.move('character', position);
        textRange.select();
      }
    },
    formatPhone() {
      let val = this.field ? this.field.replace(/[^\d.]/g, '') : '';
      let inputEleDom = this.$refs.inputEle;
      let selectionStart = inputEleDom.selectionStart;
      if (val.length > 10) {
        val = val.substr(0, 10);
      }

      let format = '(___) ___ - ____';
      let arr = format.split('');
      let position = 0;

      for (let i = 0; i < val.length; i++) {
        if (i < 3) {
          position = i + 1;
        } else if (i < 6) {
          position = i + 3;
        } else if (i < 10) {
          position = i + 6;
        }
        arr[position] = val[i];
      }

      this.$nextTick(() => {
        this.field = arr.join('');
        this.setPhonePosition(inputEleDom, selectionStart, position + 1);
      });
    },

    setPhonePosition(inputEleDom, selectionStart, position) {
      if (position > selectionStart) {
        switch (selectionStart) {
          case 1:
            position = 2;
            break;
          case 4:
          case 5:
          case 6:
            position = 7;
            break;
          case 7:
          case 10:
            position = 13;
            break;
          case 11:
          case 12:
          default:
            position = selectionStart;
        }
      }

      if (inputEleDom.setSelectionRange) {
        inputEleDom.setSelectionRange(position, position);
      } else if (inputEleDom.createTextRange) {
        var rng = inputEleDom.createTextRange();
        rng.move('character', position);
        rng.select();
      }
    },

    suggest(address) {
      let secondaryParam = '';
      if (address) {
        let secondary = encodeURIComponent(address.secondary);
        secondaryParam =
          address.street_line +
          ' ' +
          secondary +
          ' (' +
          address.entries +
          ') ' +
          address.city +
          ' ' +
          address.state +
          ' ' +
          address.zipcode;
      }

      let url = this.smartyStreetsAPI
        .concat('?key=')
        .concat(this.smartyStreetsAPIKey)
        .concat('&search=')
        .concat(encodeURIComponent(this.field.replaceAll(',', '')));
      if (secondaryParam) {
        url += '&selected=' + secondaryParam;
      } else {
        url += '&max_results=10';
      }
      let self = this;
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // 处理成功的响应
          self.suggestions = data.suggestions;

          if (self.suggestions.length > 0) {
            self.suggestionsSelect = self.suggestions.map(() => false);
            self.suggestionsSelect.shift();
          } else {
            self.setParentAddressFields(address);
          }

          self.isAutoCompleteUnitApt = !!secondaryParam;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    setAddress(address) {
      console.log('child');
      console.log(address);
      if (address.entries > 0 && !this.isAutoCompleteUnitApt) {
        this.suggest(address);
      } else {
        this.setParentAddressFields(address);
      }
    },
    getAddressText(address) {
      if (!address.text) {
        let addressSecondary = address.secondary;
        if (address.secondary) {
          if (
            address.entries > 0 &&
            address.entries !== 0 &&
            !this.isAutoCompleteUnitApt
          ) {
            let entrieLabel = address.entries === 1 ? ' entry' : ' entries';
            addressSecondary += ' (' + address.entries + entrieLabel + ')';
          }
        }
        return (
          this.spliceComma(address.street_line) +
          ' ' +
          this.spliceComma(addressSecondary) +
          ' ' +
          this.spliceComma(address.city) +
          ' ' +
          address.state +
          ' ' +
          address.zipcode
        );
      } else {
        return 'No suggestions';
      }
    },
    setParentAddressFields(address) {
      if (address.text !== 'No suggestions') {
        this.validateAddress(address);
        this.isAutoCompleteAddress1 = true;
      }
      this.suggestions = [];
    },
    formatNumber(val) {
      if (val && !/^[1-9]{1}(\d{1,2})?(,\d{3})*$/.test(val + '')) {
        let valStr = (val + '').replace(/,/g, '') + '';
        let newStr = '';
        let count = 1;

        for (let i = valStr.length - 1; i > 0; i--) {
          newStr = valStr[i] + newStr;
          if (count % 3 === 0) {
            newStr = ',' + newStr;
          }
          count++;
        }

        return valStr[0] + newStr;
      }

      return val;
    },
    focus(event) {
      if (!this.disabled) {
        this.isActive = true;

        if (this.isCurrecnyField) {
          event.target.parentElement.parentElement.parentElement.firstElementChild.style.fontFamily = 'San Francisco Weight';
        }

        if (this.isStateField) {
          this.searchKey = '';
        }

        if (!this.stdPicklist) {
          const inputElement = this.$refs.inputEle;
          inputElement.focus();

          if (this.isPicklistField) {
            this.$nextTick(() => {
              const selectedOptions = this.$refs.optionsRef.querySelectorAll('.options li.selected');
              selectedOptions.forEach(item => {
                if (item.innerText !== this.value) {
                  item.classList.remove('selected');
                }
              });

              for (let i = 1, len = this.options.length; i < len; i++) {
                if (this.options[i].value === this.value) {
                  const optionsElement = this.$refs.optionsRef;
                  optionsElement.scrollTo(0, i * 40);
                  const listItems = optionsElement.querySelectorAll('.options li');
                  listItems[i].classList.add('selected');
                  break;
                }
              }
            });
          }
        }
      }
    },

    keydown(event) {
      if (this.isStateField) {
        const optionsElem = this.$refs.mafInput.querySelector('.options');

        if (event.keyCode === 13) {
          let liElem = optionsElem.querySelector('li.selected');

          if (liElem) {
            liElem.click();
            return;
          }
        }

        let liTagheight = 40;
        if (event.keyCode && event.keyCode >= 65 && event.keyCode <= 90) {
          if (event.keyCode > 87) {
            this.searchKey = 'W';
          } else {
            this.searchKey = String.fromCharCode(event.keyCode);
          }
        }

        if (this.searchKey) {
          for (let i = 1, len = this.options.length; i < len; i++) {
            if (this.options[i].label.startsWith(this.searchKey)) {
              const optionsElement = this.$refs.optionsRef;
              optionsElement.scrollTop = liTagheight * i;
              setTimeout(() => {
                let liElem = optionsElem.querySelector('li.selected');
                if (liElem) {
                  liElem.classList.remove('selected');
                }
                optionsElem.querySelectorAll('li')[i].classList.add('selected');
              }, 10);
              return false;
            }
          }
        }
      }
    },

    keyup(event) {
      if (this.isAddressField) {
        this.isAutoCompleteAddress1 = false;
        this.isAutoCompleteUnitApt = false;
        if (typeof this.suggestions !== 'undefined') {
          this.suggestionsListener(event.keyCode);
        }
      }

      // 有充足时间待修复的功能
      /* if(this.options && this.options.length != 0){
        this.keyListner(event.keyCode);
      } */
    },

    keyListner(keyCode) {
      let liTagheight = 40;
      let liMaxShowDown = 5;
      let liMaxShowup = 6;

      if (keyCode === 38) {
        if (this.field) {
          var opt = this.getOptByKeyEvent(keyCode);
          if (this.options.length > liMaxShowup) {
            const optionsElement = this.$refs.optionsRef;
            optionsElement.scrollTop = liTagheight * opt.index;
          }
          this.setFieldByKeyEvent(opt);
        }
      } else if (keyCode === 40) {
        if (!this.field) {
          this.setFieldByKeyEvent(this.options[1]);
        } else {
          var option = this.getOptByKeyEvent(keyCode);
          if (option.index > liMaxShowDown) {
            const optionsElement = this.$refs.optionsRef;
            optionsElement.scrollTop = liTagheight * option.index;
          }
          this.setFieldByKeyEvent(opt);
        }
      } else if (keyCode === 13) {
        if (this.field) {
          this.setField(this.getOptByKeyEvent(keyCode));
        }
      }
    },
    setFieldByKeyEvent(opt) {
      this.field = opt.value;
      this.selectedOption = opt;
    },
    getOptByKeyEvent(keyCode) {
      let opt = this.getOptByField(this.field);
      if (keyCode === 38) {
        if (opt.index === 1) {
          return opt;
        } else {
          return this.options[opt.index - 1];
        }
      } else if (keyCode === 40) {
        if (opt.index === this.options.length - 1) {
          return opt;
        } else {
          return this.options[opt.index + 1];
        }
      } else if (keyCode === 13) {
        return opt;
      }
    },
    getOptByField(field) {
      let indexOptions = this.getIndexOptions();
      for (let i in indexOptions) {
        if (parseInt(field) === parseInt(indexOptions[i].value)) {
          return indexOptions[i];
        }
      }
    },

    getIndexOptions() {
      let indexOptions = [];
      for (let index = 0; index < this.options.length; index++) {
        let option = {};
        option.index = index;
        option.label = this.options[index].label;
        option.value = this.options[index].value;
        indexOptions.push(option);
      }

      return indexOptions;
    },

    suggestionsListener(keyCode) {
      let liTagheight = 40;
      let liMaxShowDown = 5;
      let liMaxShowup = 6;
      if (keyCode === 38) {
        this.index = this.indexUp();
        if (this.index < liMaxShowup) {
          // eslint-disable-next-line no-undef
          $('.suggestions').scrollTop(0);
        }
      } else if (keyCode === 40) {
        this.index = this.indexDown();
        if (this.index > liMaxShowDown) {
          // eslint-disable-next-line no-undef
          $('.suggestions').scrollTop(liTagheight * this.index);
        }
      } else if (keyCode === 13) {
        if (this.index > 0 && this.suggestionsSelect.length > 0) {
          this.isActive = false;
          this.isAutoCompleteAddress1 = true;
        }
      }
    },

    indexUp() {
      for (let i in this.suggestionsSelect) {
        i = parseInt(i);
        if (this.suggestionsSelect[i] === true) {
          if (i > 0) {
            this.suggestionsSelect[i - 1] = true;
            this.suggestionsSelect[i] = false;
            return i;
          } else {
            return 1;
          }
        }
      }
    },

    indexDown() {
      for (let i in this.suggestionsSelect) {
        i = parseInt(i);
        if (this.suggestionsSelect[i] === true) {
          if (i < this.suggestionsSelect.length - 1) {
            this.suggestionsSelect[i + 1] = true;
            this.suggestionsSelect[i] = false;
            return i + 2;
          } else {
            return this.suggestionsSelect.length;
          }
        }
      }
      this.suggestionsSelect[0] = true;
      return 1;
    },
    setField(opt) {
      this.isActive = false;
      this.field = opt.value;
      this.selectedOption = opt;
      this.selecting = false;
      this.$nextTick(() => {
        if (this.required && !this.field) {
          this.error = 'no-text';
        }
      });
    },
    blur(event) {
      this.clearErrorInput();
      if (this.required && !this.field) {
        this.error = 'no-text';
      }

      if (!this.isAddressField) {
        this.isActive = false;

        if (this.isCurrecnyField) {
          event.target.parentElement.parentElement.parentElement.firstElementChild.style.fontFamily =
            'San Francisco';
        }

        if (this.isSSNORITINField && !this.isLockField) {
          let ssnItin = this.field.replace(/[^\d]/g, '');
          if (ssnItin.length === 0 && !this.required) {
            this.error = '';
          } else if (
            ssnItin.length < 9 ||
            parseInt(ssnItin.substr(0, 3)) === 0 ||
              parseInt(ssnItin.substr(3, 2)) === 0 ||
              parseInt(ssnItin.substr(5, 4)) === 0
          ) {
            this.error = 'Please enter a valid SSN or ITIN';
          }
        }

        if (this.isMoileField && this.field) {
          let value = this.field.replace(/[^\d.]/g, '');
          if (
            value &&
            !/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/.test(
              value
            )
          ) {
            this.error = 'Please enter a valid mobile phone number';
          }
        }

        this.monitorContactPhone();

        if (this.isZipCodeField) {
          if (this.field && this.field.length < 5) {
            this.error = 'Please enter a valid zipcode';
          }
        }

        if (this.isRoutingNumberField) {
          if (this.field && this.field.length < 9) {
            this.error = 'Please enter a 9-digit routing number';
          }
        }

        if (this.isPercentageField) {
          if (!(parseInt(this.field) > 0 && parseInt(this.field) < 101)) {
            this.error = 'Please enter a percentage value between 1 and 100';
          }
        }

        if (this.isAddressField) {
          this.isAutoCompleteAddress1 = false;
          this.isAutoCompleteUnitApt = false;
        }

        if (this.isStateField) {
          this.$refs.inputEle.setAttribute('onkeyup', null);
        }
      }
    },
    clearErrorInput() {
      this.error = '';
    },
    formatPercentage() {
      let val = this.field;
      let newVal = '';
      let inputEleDom = this.$refs.inputEle;

      for (var index = 0; index < val.length; index++) {
        if (val[index] !== '%') {
          newVal += val[index];
        }
      }

      this.$nextTick(() => {
        if (newVal) {
          this.field = newVal + '%';
        }

        this.setPercentagePosition(inputEleDom, newVal.length);
      });
    },

    setPercentagePosition(ele, position) {
      if (ele.setSelectionRange) {
        setTimeout(() => {
          ele.setSelectionRange(position, position);
        }, 0);
      } else if (ele.createTextRange) {
        var rng = ele.createTextRange();
        rng.move('character', position);
        rng.select();
      }
    },
    setErrorSectionNameToParent(val) {
    },
    compareContactPhoneToMobile(mobile, contactPhone, errorMessage) {
      this.contactPhone = contactPhone;
      if (
        mobile.length === 10 &&
        contactPhone.length === 10 &&
        parseInt(mobile) === parseInt(contactPhone)
      ) {
        this.error =
          'Your alternate contact’s phone number cannot match your own mobile phone number. Please enter a different phone number.';
      } else {
        this.error = errorMessage;
      }
    },
    monitorContactPhone() {
      if (this.isMoileField && this.mobile) {
        this.compareContactPhoneToMobile(
          this.mobile.replace(/[^\d.]/g, ''),
          this.field.replace(/[^\d.]/g, ''),
          this.error
        );
      }
    },
    spliceComma(returnValue) {
      return returnValue ? returnValue.concat(',') : returnValue;
    },
    validateAddress(address) {
      let addressParams = address.street_line +
      ' ' +
      address.city +
      ', ' +
      address.state +
      ' ' +
      address.zipcode;

      let url = `${this.smartyStreetsAPI}?key=${this.smartyStreetsAPIKey}&search=${encodeURIComponent(addressParams)}`;

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          console.error('Error validating address:', error);
        });
    }
  },
  computed: {
    inputType() {
      return this.isCurrecnyField ? 'tel' : 'text';
    },
    errorMsgStyle() {
      return `width:${this.width}px; color: #F44236; margin-top: 2px;`;
    },
    symbol() {
      if (this.isCurrecnyField) {
        return '$';
      }
      return '';
    },
    color() {
      if (this.error) {
        return '#F44236';
      }

      if (this.isActive) {
        return 'url(#greenColor)';
      }

      if (this.field) {
        if (this.isCurrecnyField) {
          return '#44546A';
        }
        return '#393C40';
      }

      return '#878787';
    },
    labelColor() {
      return this.error ? this.color : this.isActive ? '#1DE9B6' : this.color;
    },
    svgColor() {
      return this.isLock ? '#E8EAEC' : '#fff';
    },
    strokeColor() {
      return this.isLock ? '#E8EAEC' : this.color;
    },
    isLock() {
      return this.disabled === true && this.isLockField;
    },
    isPicklistField() {
      return this.type === 'select';
    },
    isCurrecnyField() {
      return this.type === 'currency';
    },
    isNumberField() {
      return this.type === 'number';
    },
    isMoileField() {
      return this.type === 'mobile';
    },
    isZipCodeField() {
      return this.type === 'zipcode';
    },
    isAccountNumberField() {
      return this.type === 'accountnumber';
    },
    isRoutingNumberField() {
      return this.type === 'routingnumber';
    },
    isPercentageField() {
      return this.type === 'percentage';
    },
    isDateField() {
      return this.isDay || this.isMonth || this.isYear;
    },
    isStateField() {
      return this.name && this.name.indexOf('State') !== -1;
    },
    isSSNORITINField() {
      return this.type === 'SSN/ITIN';
    },
    isAddressField() {
      return this.type === 'address';
    },
    isShowAddress() {
      return (
        this.isAddressField &&
        this.isActive &&
        this.suggestions &&
        this.suggestions.length !== 0
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../../sass/flex-layout.scss";
.maf-input label {
  padding-bottom: 10px;
}

.maf-input .tip-icon {
  margin-left: 10px;
  float: none;
}

.maf-input .maf-s-input {
  position: relative;
  margin-top: 10px;
}

.maf-s-input input {
  position: absolute;
  top: 3px;
  left: 2px;
  outline: none;
  border: none;
  font-size: 16px;
  padding: 12px 28px;
}

.maf-input ul {
  list-style: none;
  padding: 0;
  margin-top: -4px;
  background-color: #fff;
  border: 1px solid #e6e8ed;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2.75px;
  max-height: 240px;
  overflow: auto;
  z-index: 999;
  position: relative;
}

.maf-input ul:hover {
  display: block;
}

.maf-input ul li {
  padding: 10px 0 10px 30px;
  min-height: 20px;
}

.maf-input ul li:hover,
.maf-input ul li.selected,
.maf-input ul:hover li:hover.selected {
  background-color: #359be0;
  color: #fff;
}

.maf-input ul:hover li.selected {
  background-color: #fff;
  color: inherit;
}

.tip-icon {
  position: relative;
  display: inline-block;
  text-align: center;
  background-color: #834bc4;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 15px;
  line-height: 22px;
  margin-left: 20px;
  cursor: pointer;
  font-family: San Francisco !important;
}

.tip-icon:before {
  content: '?';
  color: #fff;
}

.tip-icon:hover p {
  display: block;
  transform-origin: 100% 0%;
  -webkit-animation: fadeIn 0.3s ease-in-out;
  animation: fadeIn 0.3s ease-in-out;
}

.tip-icon p {
  display: none;
  text-align: left;
  background-color: #6b40be;
  padding: 16px;
  width: 200px;
  position: absolute;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  bottom: 32px;
  color: #fff;
  font-size: 0.9rem;
  line-height: 1.4;
  z-index: 1000;
  cursor: default;
  right: -192px;
}

.tip-icon p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-top-color: #6446b7;
  left: -12px;
  bottom: -8px;
  transform: rotate(135deg);
}

.reduced-tip {
  position: absolute;
}

@media screen and (max-width: 768px) {
  .tip-icon p {
    right: 10px;
    width: calc(100vw - 250px);
  }

  .tip-icon p:before {
    left: auto;
    right: 0px;
    bottom: -8px;
    transform: rotate(90deg);
  }

  .reduced-tip {
    right: 0px;
  }

  .reduced-tip {
    position: relative;
    margin-left: 5px
  }

  .display-flex {
    align-items: center;
    min-width: 360px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MafInput.vue